import { useEffect, useState } from 'react';
import TextModal, { type TextModalProps } from '../TextModal/TextModal';
import Pill, { type PillProps } from '../Pill/Pill';
import { Info } from '@volkswagen-onehub/icons-core';
export interface PillModalProps extends PillProps {
  modalProps: Omit<TextModalProps, 'closeModal'> & {
    onOpen?: () => void;
    onClose?: () => void;
    open?: boolean;
  };
}

const PillModal = ({
  children,
  icon = <Info variant="small" />,
  modalProps,
  ...restProps
}: PillModalProps) => {
  const { open, onClose, onOpen, title, description } = modalProps;
  const [openModal, setOpenModal] = useState(false);

  const handleShowModal = () => {
    if (onOpen) {
      onOpen();
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    }
    setOpenModal(false);
  };

  useEffect(() => {
    if (open !== undefined) setOpenModal(open);
  }, [open]);

  return (
    <>
      <Pill onClick={handleShowModal} icon={icon} {...restProps}>
        {children}
      </Pill>

      {openModal && (
        <TextModal
          title={title}
          description={description}
          closeModal={handleCloseModal}
        />
      )}
    </>
  );
};

export default PillModal;
